// Stratégies par plateforme — focus sur l'EXÉCUTION (vs algorithmes qui = théorie)
export const STRATEGIES = {
  instagram: {
    slug: "instagram",
    name: "Instagram",
    icon: "Instagram",
    color: "#E1306C",
    tagline: "Le couteau-suisse : Reels, Stories, Feed, DM, Lives.",
    sections: [
      {
        title: "Formats à mixer en 2026",
        items: [
          { head: "Reels (80% reach)", body: "Le vecteur principal. 70% trends + 20% original + 10% expérimental.", details: {
            intro: "Les Reels représentent 80% du push organique IG en 2026. Sans Reels, ton compte ne grandit plus.",
            actions: ["Poster 5-7 Reels/semaine minimum", "Mixer 70/20/10 trends/original/exp", "Story du Reel 1h après publication"],
            checklist: ["Hook 0-1s", "Loop invisible", "Sous-titres dynamiques", "CTA invisible en caption", "Format 9:16 plein écran"],
            kpis: [{ label: "Watchtime", value: "≥ 70%" }, { label: "Save rate", value: "≥ 4%" }],
            errors: ["Watermark TT/CapCut visible (-40% push)", "Pas de hook 0-1s (skip 70%)"],
            proTips: ["Story du Reel 1h après publication = boost watchtime indirect.", "Cross-post Threads dans les 5 minutes."]
          }},
          { head: "Stories (proximity)", body: "Pas de reach mais profondeur audience. 3-7 stories/jour, hook dès la première.", details: {
            intro: "Les Stories ne donnent pas de reach mais elles construisent la profondeur d'audience nécessaire à la fidélisation.",
            actions: ["3-7 stories/jour", "Première story = hook fort", "Dernière = CTA (sondage, question, lien)"],
            checklist: ["Sondages au moins 1 fois/jour", "Question sticker au moins 1 fois/semaine", "Repost UGC + témoignages"],
            kpis: [{ label: "Story completion", value: "≥ 70%" }, { label: "Reply rate", value: "≥ 1%" }],
            errors: ["Stories sans intention (juste 'lifestyle')", "Trop de stories (>15) → désaboo"],
            proTips: ["Story interactive = +200% engagement post suivant. Algo voit ton compte comme 'hot'."]
          }},
          { head: "Feed Posts (branding)", body: "Photos / Carousels. Plus de save rate que Reels mais moins de reach. Carousels sont rois pour value.", details: {
            intro: "Les carousels ont le meilleur save rate de tous les formats. Idéal pour value content éducatif.",
            actions: ["1-2 carousels/semaine", "8-10 slides max", "Slide 1 = hook visuel + texte"],
            checklist: ["Slide 1 hook impactant", "Slide finale CTA save/share", "Couleurs cohérentes brand", "Lecture 30s+ par carousel"],
            kpis: [{ label: "Save rate", value: "≥ 8%" }, { label: "Share rate", value: "≥ 1.5%" }],
            errors: ["Slides trop chargés", "Pas de CTA save final"],
            proTips: ["Last slide = 'Save pour relire' → save rate x3."]
          }},
          { head: "Lives (intimité)", body: "1-2x/mois minimum. Algo IG push les comptes qui font des lives réguliers." },
          { head: "DMs (conversion)", body: "Canal #1 pour transformer. 10-25 DMs personnalisés/jour max." },
        ]
      },
      {
        title: "Stratégie de croissance IG",
        items: [
          { head: "Pyramide Reach", body: "Foundation : Reels viraux. Middle : Stories engagement. Top : DM conversion. Tout part du Reel." },
          { head: "Cross-format leverage", body: "Un Reel viral = 3 Stories + 1 Carousel insights + 5 hooks Threads. Chaque viral nourri 9 contenus secondaires." },
          { head: "DM funnel", body: "Hook viral → Comment 'X' → Auto-DM avec lead magnet → Email list. Conversion view→email = 2-5%." },
        ]
      }
    ]
  },

  tiktok: {
    slug: "tiktok",
    name: "TikTok",
    icon: "Music2",
    color: "#FF0050",
    tagline: "Vitesse + volume + loops = explosion virale.",
    sections: [
      {
        title: "Formats prioritaires",
        items: [
          { head: "Format vertical 9:16 plein écran", body: "Aucun bandeau, aucun cadre. Pleine immersion." },
          { head: "Vidéos 8-15s pour test cold", body: "Plus court = completion rate plus élevé = test cold passe vite." },
          { head: "Vidéos 30-60s pour scaling", body: "Une fois validé, étirer la durée pour maximiser watchtime." },
          { head: "Lives + Lives Match", body: "Push secondaire massif. Algo TT favorise les lives ≥ 30 min." },
        ]
      },
      {
        title: "Stratégies de scaling",
        items: [
          { head: "Sound trending ride", body: "Repérer un son <14j sur Creative Center → adapter à ta niche → publier dans les 48h.", details: {
            intro: "Un son trending est une fenêtre de 5-10 jours. Arriver tôt = explosion. Arriver tard = bruit.",
            actions: ["Vérifier TikTok Creative Center quotidiennement", "Repérer sons en hausse <7j", "Adapter avec hook custom 0-1s", "Publier dans les 48h"],
            checklist: ["Son <14j d'ancienneté", "Format 9:16 9s-15s", "Hook custom adapté à ta niche"],
            kpis: [{ label: "Boost reach son trending", value: "x2 vs son cold" }],
            errors: ["Arriver après J10 du son → noyé dans bruit", "Utiliser le son sans adapter à ta niche"],
            proTips: ["Sweet spot : son utilisé 3K-15K fois → encore push, déjà validé."]
          }},
          { head: "Loop infini visuel", body: "Dernière frame = première frame. Re-watch automatique = +200% watchtime." },
          { head: "Reply vidéo cascade", body: "Réponse vidéo aux commentaires = boost original + nouveau viral." },
          { head: "Stitch / Duet stratégique", body: "Stitch un viral d'une niche adjacente = piggyback massif." },
        ]
      }
    ]
  },

  youtube: {
    slug: "youtube",
    name: "YouTube Shorts",
    icon: "Youtube",
    color: "#FF0000",
    tagline: "Watchtime le plus long. Monétisation directe RPM.",
    sections: [
      {
        title: "Formats prioritaires",
        items: [
          { head: "Shorts 30-60s", body: "Sweet spot YT : plus long que TT, audience plus tolérante." },
          { head: "Vidéos longues 8-15 min", body: "Le vrai $ vient de là. Shorts amène le subscriber, longue monétise." },
          { head: "Community Posts", body: "Sondages + textes pour engager les subscribers entre vidéos." },
        ]
      },
      {
        title: "Funnel YouTube",
        items: [
          { head: "Shorts → Subs → Vidéo Longue", body: "Le funnel ultime : Shorts viraux convertissent en subs, qui consomment la vidéo longue, qui monétise." },
          { head: "End-screens stratégiques", body: "Lien vers vidéo longue dans description Shorts + end-screen optimisé." },
          { head: "Playlists thématiques", body: "Chaque viral Short → ajouté à playlist → boost watchtime canal global." },
        ]
      }
    ]
  },

  threads: {
    slug: "threads",
    name: "Threads",
    icon: "AtSign",
    color: "#FFFFFF",
    tagline: "Le réseau gratuit. Reach 10x facile en 2026.",
    sections: [
      {
        title: "Formats qui cartonnent",
        items: [
          { head: "Hot take court (1-2 phrases)", body: "Polarisation = engagement = push." },
          { head: "Liste numérotée value", body: "5 trucs que personne ne te dit sur X. Format saveable." },
          { head: "Quote thread soi-même", body: "Continuation de thought = push 2e vague." },
          { head: "Question rhétorique punchy", body: "Pousse à répondre. Replies = signal hot." },
        ]
      },
      {
        title: "Routine traffic gratuit",
        items: [
          { head: "Reply first sous gros posts", body: "Réponse first 30min sous gros = vue par tous les viewers du gros post. 10K-100K vues gratuites." },
          { head: "Lien IG/TT en bio", body: "Conversion gratuite vers ta plateforme principale." },
          { head: "Cross-post depuis IG", body: "Reels IG → texte Threads adapté → reach gratuit." },
        ]
      }
    ]
  },

  x: {
    slug: "x",
    name: "X / Twitter",
    icon: "Twitter",
    color: "#FFFFFF",
    tagline: "Arène d'opinions. Le tranché explose.",
    sections: [
      {
        title: "Formats viraux 2026",
        items: [
          { head: "Thread structuré 8-12 tweets", body: "Hook + payoff par tweet + CTA fin." },
          { head: "Quote tweet réaction", body: "Réagir à un viral avec angle unique = piggyback." },
          { head: "Poll polarisant", body: "Force la prise de position = engagement maximum." },
        ]
      },
      {
        title: "Hooks textuels qui marchent",
        items: [
          { head: "'Hot take:'", body: "Signal direct : position tranchée à venir." },
          { head: "'Personne ne te dira ça:'", body: "Curiosity gap textuel." },
          { head: "'En 2026, les X qui font Y vont mourir.'", body: "Prédiction = engagement viral." },
          { head: "Listes 'X erreurs/X leçons/X règles'", body: "Format saveable + bookmark." },
        ]
      }
    ]
  },

  snap: {
    slug: "snap",
    name: "Snapchat",
    icon: "Ghost",
    color: "#FFFC00",
    tagline: "Spotlight + Audience Gen Z 13-24 ultra engagée.",
    sections: [
      {
        title: "Formats Spotlight",
        items: [
          { head: "Vidéos 5-15s 9:16", body: "Plein écran obligatoire." },
          { head: "Audio Snap natif", body: "Push algo favorable." },
          { head: "Captions punchy", body: "Format Snap-natif : ton fun, raw, authentique." },
        ]
      }
    ]
  },

  clapper: {
    slug: "clapper",
    name: "Clapper",
    icon: "Clapperboard",
    color: "#1DB954",
    tagline: "Réseau émergent. Audience 35-65 fort pouvoir d'achat.",
    sections: [
      {
        title: "Pourquoi y aller en 2026",
        items: [
          { head: "Reach gratuit 5-10x supérieur", body: "Plateforme jeune, peu de créateurs." },
          { head: "Audience 35-65", body: "Fort pouvoir d'achat = monétisation rapide." },
          { head: "Lives + DMs directs", body: "Conversion DM élevée vs autres plateformes." },
        ]
      }
    ]
  }
};

export const STRATEGY_LIST = Object.values(STRATEGIES);
